<template>
	<v-form>
		<v-text-field
			v-model="oldPassword"
			label="Altes Passwort"
      type="password"
			required
		/>
		<v-text-field
			v-model="newPassword"
			label="Neues Passwort"
			type="password"
			required
		/>
    <v-text-field
			v-model="newPasswordAgain"
			label="Neues Passwort wiederholen"
			type="password"
			required
		/>
		 <v-btn
			color="primary"
			:loading="loading"
			@click="changePassword"
			type="submit"
		>
			Ändern
		</v-btn>
		<v-snackbar v-model="showMessages" v-for="(message, index) in messages" v-bind="message" :key="index">
			{{message.message}}
		</v-snackbar>
	</v-form>
</template>

<script>
import user from '@/services/user.js';
export default {
	data() {
    user.fetchUser()
		return {newPassword: '', oldPassword: '', newPasswordAgain: '', messages: [], loading: false, showMessages: true}
	},
	methods: {
		changePassword() {
      if (this.newPassword != this.newPasswordAgain) {
        this.messages.push({
          message: 'Passwörter sind nicht gleich',
          color: 'error'
        })
        return
      }
      this.loading = true
			user.changePassword(this.newPassword, this.oldPassword).then(res => {
				this.$router.push({name: 'Home'})
				this.loading = false;
				this.messages.push({
					message: `Angemeldet als ${res}`
				})
				location.reload()
			}).catch(e => {
				this.loading = false;
				this.messages.push({
					message: `Passwort ändern ist fehlgeschlagen: ${e}`,
					color: 'error'
				})
			})
		}
	}
}
</script>

<style>

</style>
